'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vertical = exports.baseStyles = undefined;

var _styledComponents = require('styled-components');

/**
 * A collection of layouts
 * @private
 * @type {Object}
 */
var layouts = {
  /**
   * A collection of AB layouts
   * @type {Object}
   */
  AB: {},
  /**
   * A collection of ABC layouts
   * @type {Object}
   */
  ABC: {}
};

exports.default = layouts;

/**
 * Basic styles used in layouts
 * @private
 */

var baseStyles = exports.baseStyles = (0, _styledComponents.css)(['--default-font-family:-apple-system,BlinkMacSystemFont,\'Segoe UI\',Roboto,Oxygen,Ubuntu,Cantarell,\'Open Sans\',\'Helvetica Neue\',sans-serif;font-family:var(--font-family,var(--default-font-family));font-size:var(--font-size,2rem);']);

/**
 * Vertical alignment helpers
 * @private
 * @type {Object}
 */
var vertical = exports.vertical = {};

/**
 * Vertical alignemt using flexbox
 * @private
 */
vertical.base = (0, _styledComponents.css)(['display:flex;flex-direction:column;align-items:center;align-content:center;']);

/**
 * Vertically align top
 * @private
 */
vertical.start = (0, _styledComponents.css)(['', ';justify-content:flex-start;'], vertical.base);

/**
 * Vertically align bottom
 * @private
 */
vertical.end = (0, _styledComponents.css)(['', ';justify-content:flex-end;'], vertical.base);

/**
 * Vertically align bottom
 * @private
 */
vertical.center = (0, _styledComponents.css)(['', ';justify-content:center;'], vertical.base);

/**
 * Base layout
 * @private
 */
layouts.base = (0, _styledComponents.css)(['', ';display:grid;[data-slot=\'A\']{grid-area:slotA;}[data-slot=\'B\']{grid-area:slotB;}[data-slot=\'C\']{grid-area:slotC;}[data-slot=\'D\']{grid-area:slotD;}'], baseStyles);

/**
 * Layout for A
 * @private
 */
layouts.A = (0, _styledComponents.css)(['', ';grid-template-columns:1fr;grid-template-rows:1fr;grid-template-areas:\'slotA\';'], layouts.base);

/**
 * Layout for AB
 * @private
 */
layouts.AB.topBottom = (0, _styledComponents.css)(['', ';grid-template-columns:1fr;grid-template-rows:1fr 1fr;grid-template-areas:\'slotA\' \'slotB\';'], layouts.base);

/**
 * Layout for AB
 * @private
 */
layouts.AB.leftRight = (0, _styledComponents.css)(['', ';grid-template-columns:1fr 1fr;grid-template-rows:1fr;grid-template-areas:\'slotA slotB\';'], layouts.base);

/**
 * Layout for ABC
 * @private
 */
layouts.ABC.top = (0, _styledComponents.css)(['', ';grid-template-columns:1fr 1fr;grid-template-rows:1fr 1fr;grid-template-areas:\'slotA slotA\' \'slotB slotC\';'], layouts.base);

/**
 * Layout for ABC
 * @private
 */
layouts.ABC.right = (0, _styledComponents.css)(['', ';grid-template-columns:1fr 1fr;grid-template-rows:1fr 1fr;grid-template-areas:\'slotB slotA\' \'slotC slotA\';'], layouts.base);

/**
 * Layout for ABC
 * @private
 */
layouts.ABC.bottom = (0, _styledComponents.css)(['', ';grid-template-columns:1fr 1fr;grid-template-rows:1fr 1fr;grid-template-areas:\'slotB slotC\' \'slotA slotA\';'], layouts.base);

/**
 * Layout for ABC
 * @private
 */
layouts.ABC.left = (0, _styledComponents.css)(['', ';grid-template-columns:1fr 1fr;grid-template-rows:1fr 1fr;grid-template-areas:\'slotA slotB\' \'slotA slotC\';'], layouts.base);

/**
 * Layout for ABCD
 * @private
 */
layouts.ABCD = (0, _styledComponents.css)(['', ';grid-template-columns:1fr 1fr;grid-template-rows:1fr 1fr;grid-template-areas:\'slotA slotB\' \'slotC slotD\';'], layouts.base);